// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rw-widget-input{\n    height: 38px;\n}\n\n.styled__control-is-focused{\n    \n}\n\n.styled__control-is-focused:hover{\n    background-color: red;\n}", ""]);
// Exports
module.exports = exports;
